/**
 * Workout Builder and Sortable Utilities for IronHUD (Alpine.js Components)
 */

export const WorkoutBuilderComponent = () => ({
    checkUserKeydown(event) {
        const ignoredKeys = [
            'Tab',
            'Shift',
            'Enter',
            'Escape',
            'ArrowUp',
            'ArrowDown',
            'ArrowLeft',
            'ArrowRight',
        ];
        return !ignoredKeys.includes(event.key);
    },

    syncExerciseId(input) {
        // Find the datalist associated with the input
        const listId = input.getAttribute('list');
        const list = document.getElementById(listId);
        if (!list) return;

        const container = input.closest('.relative');
        const hiddenId = container.querySelector('input[name="exercise_id"]');
        const badge = container.querySelector('.new-badge');

        const selectedOption = Array.from(list.options).find(
            (option) => option.value === input.value
        );

        if (selectedOption) {
            hiddenId.value = selectedOption.getAttribute('data-id');
            if (badge) badge.classList.add('hidden');
        } else {
            hiddenId.value = '';
            if (badge) {
                if (input.value.trim().length > 2) badge.classList.remove('hidden');
                else badge.classList.add('hidden');
            }
        }
    },

    addExerciseRow(listId, templateId) {
        const list = document.getElementById(listId);
        const template = document.getElementById(templateId);
        if (!list || !template) return;

        const newItem = template.content.cloneNode(true).firstElementChild;
        list.appendChild(newItem);

        // HTMX processing for the new element
        if (window.htmx) {
            window.htmx.process(newItem);
        }
    },
});

export const SortableListComponent = (config = {}) => ({
    initialOrder: '',

    init() {
        this.$nextTick(() => {
            this.setup();
        });
    },

    setup() {
        const el = this.$el;
        if (!el || typeof Sortable === 'undefined') return;

        const inputName = config.inputName || 'workout_ids';
        const formSelector = config.formSelector;

        this.initialOrder = this.getCurrentOrder(inputName);

        new Sortable(el, {
            animation: 250,
            ghostClass: 'bg-brand-primary/10',
            handle: config.handle || '.cursor-move',
            draggable: config.draggable || '>*',
            onEnd: () => {
                const currentOrder = this.getCurrentOrder(inputName);
                if (currentOrder !== this.initialOrder) {
                    this.initialOrder = currentOrder;
                    if (formSelector) {
                        const form = document.querySelector(formSelector);
                        if (form && window.htmx) {
                            window.htmx.trigger(form, 'submit');
                        }
                    }
                }
            },
        });
    },

    getCurrentOrder(inputName) {
        return Array.from(this.$el.querySelectorAll(`input[name="${inputName}"]`))
            .map((i) => i.value)
            .join(',');
    },
});
